import React from 'react';
import { Music, Users, Calendar, Camera, Globe } from 'lucide-react';

const Home = ({ language }) => {
  const content = {
    en: {
      title: 'Choir Web - Complete Choir Management System',
      subtitle: 'Create beautiful websites and manage your choir with our comprehensive CMS platform',
      cta: 'Start Your Free Trial',
      features: [
        { icon: Camera, title: 'Photo Albums', desc: 'Showcase your choir with beautiful photo galleries' },
        { icon: Users, title: 'Member Management', desc: 'Complete member registration and management system' },
        { icon: Calendar, title: 'Event Calendar', desc: 'Schedule rehearsals, concerts, and events' },
        { icon: Globe, title: 'Multi-Language', desc: 'Support for multiple languages and regions' }
      ]
    },
    es: {
      title: 'Choir Web - Sistema Completo de Gestión Coral',
      subtitle: 'Crea sitios web hermosos y gestiona tu coro con nuestra plataforma CMS integral',
      cta: 'Comienza tu Prueba Gratuita',
      features: [
        { icon: Camera, title: 'Álbumes de Fotos', desc: 'Muestra tu coro con hermosas galerías de fotos' },
        { icon: Users, title: 'Gestión de Miembros', desc: 'Sistema completo de registro y gestión de miembros' },
        { icon: Calendar, title: 'Calendario de Eventos', desc: 'Programa ensayos, conciertos y eventos' },
        { icon: Globe, title: 'Multi-idioma', desc: 'Soporte para múltiples idiomas y regiones' }
      ]
    },
    sv: {
      title: 'Choir Web - Komplett Körhanteringssystem',
      subtitle: 'Skapa vackra webbplatser och hantera din kör med vår omfattande CMS-plattform',
      cta: 'Starta din Gratis Provperiod',
      features: [
        { icon: Camera, title: 'Fotoalbum', desc: 'Visa upp din kör med vackra fotogallerier' },
        { icon: Users, title: 'Medlemshantering', desc: 'Komplett medlemsregistrering och hanteringssystem' },
        { icon: Calendar, title: 'Evenemangskalender', desc: 'Schemalägg repetitioner, konserter och evenemang' },
        { icon: Globe, title: 'Flerspråkigt', desc: 'Stöd för flera språk och regioner' }
      ]
    }
  };

  const t = content[language];

  return (
    <div>
      <div className="hero">
        <h1>{t.title}</h1>
        <p>{t.subtitle}</p>
        <button className="cta-button">{t.cta}</button>
      </div>
      
      <div className="container">
        <div className="features-grid">
          {t.features.map((feature, index) => (
            <div key={index} className="feature-card">
              <feature.icon size={48} className="feature-icon" />
              <h3>{feature.title}</h3>
              <p>{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;